import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './app'
import { version } from './version'

console.log(
  '%c Ponder Website %c ' + version.semantic_version + ' ',
  'background:#4C097C; color:#fff; font-weight:bold; padding:2px 6px; border-radius:3px 0 0 3px;',
  'background:#7B2CBF; color:#fff; font-weight:bold; padding:2px 6px; border-radius:0 3px 3px 0;',
)
if (!import.meta.env.DEV) {
  console.log(
    '  build   ' + version.full_version + '\n' +
    '  sha     ' + version.git_sha + '\n' +
    '  by      ' + version.deployed_by + '\n' +
    '  at      ' + version.deployed_at,
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
